<template>
  <q-section v-bind="$attrs">
    <q-section
      v-if="showUser1"
      :bg-i="props.user1.avatar_url"
      :key="props.user1.avatar_url"
      :pl="showUser2 ? '0' : undefined"
      :pc="showUser2 ? undefined : 'x'"
      :wh="userSize"
      bdr="50%"
      @click="handleAvatarClick(props.user1.user_id)"></q-section>
    <q-section
      v-if="showUser2"
      :bg-i="props.user2.avatar_url"
      :key="props.user2.avatar_url"
      :pr="showUser1 ? '0' : undefined"
      :pc="showUser1 ? undefined : 'x'"
      :wh="userSize"
      bdr="50%"
      pz="5"
      @click="handleAvatarClick(props.user2.user_id)"></q-section>
    <slot></slot>
  </q-section>
</template>

<script setup lang="ts">
const props = defineProps({
  user1: {
    type: Object,
    default: () => ({}),
  },
  user2: {
    type: Object,
    default: () => ({}),
  },
  showUser1: {
    type: Boolean,
    default: true,
  },
  showUser2: {
    type: Boolean,
    default: true,
  },

  userSize: {
    type: [String, Number],
    default: 33,
  },
})

const emit = defineEmits<{
  (e: 'avatarClick', userId: number): void
}>()

const handleAvatarClick = (userId: number) => {
  emit('avatarClick', userId)
}
</script>

<style scoped lang="scss"></style>
